export const capitalizeWords = (str?: string): string => {
  if (!str) return '';
  return str
    .split(' ')
    .map(str => str
      .charAt(0)
      .toUpperCase() +
      str
        .slice(1).toLowerCase())
    .join(' ');
};